import type { AdminPageAccessRule } from '../../registry.ts';

/** Хто бачить сторінку `jobs`: у перший екран їде лише це (опис і код — у `page.ts`). */
export default {
  group: 'data',
  permission: ['jobs.manage', 'users.manage'],
} satisfies AdminPageAccessRule;
